<template>
	<small :class="`text-${color}`" v-bind="$attrs">
		<slot></slot>
	</small>
</template>

<script>
	export default {
		name: 'AppSmall',
		props: {
			color: {
				type: String,
				default: 'invert',
			},
		},
	};
</script>

<style scoped>
	small {
		@apply text-13;
		@apply leading-normal;
	}
</style>
